<template lang="html">
  <v-dialog
    scrollable
    :value="true"
    max-width="500"
    persistent
  >
    <v-form
      @submit.prevent="saveItem"
      v-model="isValid"
      ref="form"
      style="width:100%"
    >
      <v-card :class="{large: !appSmall}">
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          {{recordId === 'new' ? 'Create' : 'Edit'}} Machine {{record.id ? '#' + record.id : ''}}
        </v-card-title>

        <v-card-text class="pb-0 pt-4" v-if="!initialLoading">
          <v-layout wrap>
            <v-flex xs12 md6>
              <v-text-field
                label="Machine Name"
                outlined
                v-model="record.name"
                :disabled="loading"
                :rules="[...validation.required]"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                label="Location"
                outlined
                v-model="record.location"
                :disabled="loading"
                :rules="[...validation.required]"
              ></v-text-field>
            </v-flex>
          </v-layout>
          <v-layout wrap>
            <v-flex xs12 md6>
              <v-select
                :items="companies.map(c => ({text: c.name, value: c.id})) "
                v-model="record.company"
                outlined
                label="Company"
                :disabled="loading"
                :rules="[...validation.required]"
              ></v-select>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field
                label="Film Break Cost"
                outlined
                v-model="record.film_break_cost"
                :disabled="loading"
                :rules="[...validation.required]"
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>

        <v-divider></v-divider>

        <v-alert :value="true" type="error" style="width:100%" v-if="error">{{error}}</v-alert>

        <v-card-actions>
          <v-btn
            v-if="!loading"
            @click="$emit('close')"
            text
          >
            Cancel
          </v-btn>
          <v-spacer></v-spacer>
          <v-progress-circular
            v-if="loading"
            class="ma-2"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-spacer></v-spacer>
          <v-btn
            v-if="!loading"
            color="primary"
            text
            type="submit"
          >
            Save
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<style lang="scss" scoped>
.large {
  .layout {
    .flex:first-child {
      padding-right: 8px;
    }
    .flex:last-child {
      padding-left: 8px;
    }
  }
}
</style>

<script>
import { mapState, mapActions } from 'vuex'
import cloneDeep from 'lodash/cloneDeep'
import pick from 'lodash/pick'
import get from 'lodash/get'
import ValidationMixin from '@/mixins/ValidationMixin'

export default {
  mixins: [ValidationMixin],
  props: {
    recordId: {
      type: String
    }
  },
  data () {
    return {
      record: {},
      error: null,
      initialLoading: false
    }
  },
  computed: {
    ...mapState(['user']),
    ...mapState('machines', ['loading']),
    ...mapState('companies', {
      companies: 'data'
    })
  },
  methods: {
    ...mapActions('machines', {
      save: 'save',
      getItem: 'get'
    }),
    async saveItem () {
      if (!this.isValid) {
        this.$refs.form.validate()
        return
      }
      this.error = null
      try {
        this.record = await this.save(pick(this.record, ['id', 'name', 'location', 'company', 'film_break_cost']))
        this.$emit('close')
      } catch (e) {
        this.error = get(e, 'response.data') || e
        throw e
      }
    }
  },
  async created () {
    if (this.recordId) {
      this.initialLoading = true
      try {
        let record = {
          company: this.user.company,
          film_break_cost: 0
        }
        if (this.recordId !== 'new') {
          record = await this.getItem(this.recordId)
        }
        this.record = cloneDeep(record)
        this.initialLoading = false
      } catch (e) {
        this.initialLoading = false
        throw e
      }
    }
  }
}
</script>
